import * as Sentry from "@sentry/react";

declare const GIT_COMMIT: string;

if (!["localhost", "127.0.0.1"].includes(window.location.hostname)) {
	Sentry.init({
		dsn: "https://1cfee24f66435a21fabb5ff41ce46a49@o4508772574298112.ingest.us.sentry.io/4511162173358080",

		// Alternatively, use `process.env.npm_package_version` for a dynamic release version
		// if your build tool supports it.
		release: `newqueue@${GIT_COMMIT}`,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for tracing.
		// We recommend adjusting this value in production
		// Learn more at
		// https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
		tracesSampleRate: 0.05,

		// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
		tracePropagationTargets: ["localhost", /^https:\/\/queue\.designforcemarketing\.com/],

		// Capture Replay for 10% of all sessions,
		// plus for 100% of sessions with an error
		// Learn more at
		// https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,

		enableLogs: true,
	});

	Sentry.setUser((window as any).SENTRY_USER);
	document.addEventListener("turbo:render", () => Sentry.setUser((window as any).SENTRY_USER));
}
